import { Link, graphql, useStaticQuery } from "gatsby";
import * as React from "react";
//
import { DownloadAppCallToAction } from "./DownloadAppCallToAction";
import { FooterSubSegment, FooterSubSegmentItem } from "./FooterSubSegment";
import { MENU } from "../Header";
import { LayoutContainer } from "../LayoutContainer";

const SITEMAP: FooterSubSegmentItem[] = [
  {
    name: "Home",
    url: "/",
  },
  ...MENU,
];

export const Footer = () => {
  const rawData = useStaticQuery(graphql`
    query {
      sanityBasicSettings {
        address
        email
        phone
        social {
          name
          url
        }
      }
    }
  `);

  const data = rawData.sanityBasicSettings;

  const social: FooterSubSegmentItem[] = data.social;
  const contact: FooterSubSegmentItem[] = [
    { name: data.phone, url: `tel:${data.phone}` },
    { name: data.email, url: `mailto:${data.email}` },
    { name: data.address },
  ];

  return (
    <LayoutContainer>
      <div className="py-20 flex flex-col gap-12 items-center md:items-start md:flex-row justify-between">
        <DownloadAppCallToAction />
        <FooterSubSegment items={SITEMAP} label="Sitemap" />
        <FooterSubSegment items={social} label="Socials" />
        <FooterSubSegment items={contact} label="Contact" />
      </div>
      <div className="border-t border-gray-500 py-5 text-sm flex justify-between items-center opacity-50">
        <div className="space-x-6">
          <Link to="/legal/privacy">Privacy Policy</Link>
          {/* <Link to="/legal/terms">Terms Of Service</Link> */}
        </div>
        <span>&copy; {new Date().getFullYear()} Quizzario Private Limited</span>
      </div>
    </LayoutContainer>
  );
};
